import * as React from 'react';
import { Box } from '@mui/material';

interface ColouredDotProps {
    color?: string
}

function ColouredDot(props: ColouredDotProps): JSX.Element {
    return <Box sx={{
        border: "1px solid " + props.color,
        backgroundColor: props.color,
        borderRadius: "50%",
        display: "inline-block",
        height: "14px",
        width: "14px",
        marginRight: "5px"
    }}/>
}

export default ColouredDot;